module.exports = __webpack_public_path__ + "media/images/icons/payment-3d9637a61cedf5802df427e6af05a179.svg";